"use client";

import { LanguageProvider } from "../../i18n";
import { PricingContent } from "../../pricing/PricingContent";

/**
 * NL sibling of /pricing — reuses the same content with the Dutch
 * locale pinned so the page copy, CTAs, and SiteNav resolve correctly.
 * Mirrors the same pattern as /nl/page.tsx for the landing.
 */
export default function PricingPageNL() {
  return (
    <LanguageProvider initialLang="nl">
      <PricingContent />
    </LanguageProvider>
  );
}
